/**
 * Date Range Field Component
 * Start and end date pickers for date range filtering
 */

import React from 'react'
import { TextField, Typography, Box, Stack } from '@mui/material'

interface DateRangeFieldProps {
  startDate: string
  endDate: string
  onStartDateChange: (value: string) => void
  onEndDateChange: (value: string) => void
  startLabel?: string
  endLabel?: string
}

const labelStyle = {
  fontWeight: 600,
  color: 'text.secondary',
  fontSize: '0.75rem',
  mb: 0.5,
  display: 'block',
}

const DateRangeField: React.FC<DateRangeFieldProps> = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  startLabel = 'Start Date',
  endLabel = 'End Date',
}) => {
  return (
    <Stack direction="row" spacing={2}>
      <Box flex={1}>
        <Typography component="label" sx={labelStyle}>
          {startLabel}
        </Typography>
        <TextField
          fullWidth
          size="small"
          type="date"
          value={startDate}
          onChange={(e) => onStartDateChange(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
      </Box>
      <Box flex={1}>
        <Typography component="label" sx={labelStyle}>
          {endLabel}
        </Typography>
        <TextField
          fullWidth
          size="small"
          type="date"
          value={endDate}
          onChange={(e) => onEndDateChange(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
      </Box>
    </Stack>
  )
}

export default DateRangeField
